import type { ReactNode } from 'react';

import { useAuth } from '@/Client/State';
import { CommonActionButton } from '@kaiizen/kai-shiki/react';
import { DEFAULT_SUPER_ADMIN_MODAL_STYLES, SuperAdminModalStyles } from './superAdminModalStyles';

interface SuperAdminModalProps {
  visible: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  styles?: SuperAdminModalStyles;
}

/** The full-screen frame the super-admin tools (feature flags, suppliers) open in; renders nothing for anyone else. */
export const SuperAdminModal = ({ visible, title, onClose, children, styles = DEFAULT_SUPER_ADMIN_MODAL_STYLES }: SuperAdminModalProps) => {
  const { isSuperAdmin } = useAuth();
  if (!visible || !isSuperAdmin) return null;

  return (
    <div css={styles.overlay} onClick={onClose}>
      <div css={styles.content} onClick={event => event.stopPropagation()}>
        <div css={styles.header}>
          <div css={styles.title}>{title}</div>
          <CommonActionButton style={styles.closeButton} onClick={onClose}>{'Close'}</CommonActionButton>
        </div>
        <div css={styles.body}>{children}</div>
      </div>
    </div>
  );
};
